import { Divider, message } from "antd"
import React, { useEffect, useState } from "react"
import { createSearchParams, useNavigate, useParams } from "react-router-dom"
import CancelButton from "../../components/CancelButton"
import Head from "../../components/Head"
import Button from "../../components/UI/Button"
import Input from "../../components/UI/Input"
import Radio from "../../components/UI/Radio"
import SelectInput from "../../components/UI/SelectInput"
import SmartSearch from "../../components/UI/SmartSearch"
import {createOrUpdateDevice, getDeviceById, pushDeviceCommand} from "../../services/devices"
import { notificationError } from "../../services/notification"
import deviceStatus from "../../utils/deviceStatus"
import { onlySpaces } from "../../utils/formValidation"
import { findRelativeStatus } from "../../utils/objectUtils"
import {onlyNumbersAsString} from "../../utils/stringUtils";
import {getLocationById} from "../../services/locations";
import devicesCommandList from "../../utils/devicesCommandList";
import {useAuth} from "../../context/AuthProvider/useAuth";

function NewDevice() {
  const {id} = useParams()

  const history = useNavigate()
  const  affiliation  = useAuth().response?.affiliation

  const statusOptions = [
    {label: 'Available', value: deviceStatus.available},
    {label: 'Inactive', value: deviceStatus.inactive},
    {label: 'Blocked', value: deviceStatus.blocked},
  ]
  const typeOptions = [
    {label: 'POS', value: 'pos'},
    {label: 'GAME', value: 'game'},
  ]
  const gameTypeOptions = [
    {label: 'All', value: 'all'},
    {label: 'Pull-Tab Only', value: 'pulltabOnly'},
    {label: 'Bingo Only', value: 'bingoOnly'}
  ]
  const [form, setForm] = useState({
    identifier: '',
    alias: '',
    status: statusOptions[0].value,
    type: typeOptions[0].value,
    locationId: '',
    gameType: gameTypeOptions[0].value,
    allowSingleUse: false
  })
  const [orig, setOrig] = useState({
    identifier: '',
    alias: '',
    status: statusOptions[0].value,
    type: typeOptions[0].value,
    locationId: '',
    gameType: gameTypeOptions[0].value
  })
  const [search, setSearch] = useState('')
  const [params, setParams] = useState({
    charity: '',
    distributor: '',
    search: {
      id: '',
      name: '',
      type: '',
    }
  })
  const [validSearch, setValidSearch] = useState(false)
  const [singleUse, setSingleUse] = useState({
    allowSingleUse: false
  })

  useEffect(() => {
    if(id) {
      (async () => {
        const response = await getDeviceById({id: id})
        if(response && response.id) {
          setForm({
            identifier: response.identifier,
            alias: response.alias,
            status: findRelativeStatus(response.status, statusOptions),
            type: findRelativeStatus(response.type, typeOptions),
            locationId: response.locationId,
            gameType: response.gameType && findRelativeStatus(response.type, typeOptions) === typeOptions[1].value ? findRelativeStatus(response.gameType, gameTypeOptions) : gameTypeOptions[0].value,
            allowSingleUse: response.allowSingleUse
          })
          setOrig({
            identifier: response.identifier,
            alias: response.alias,
            status: findRelativeStatus(response.status, statusOptions),
            type: findRelativeStatus(response.type, typeOptions),
            locationId: response.locationId,
            gameType: response.gameType && findRelativeStatus(response.type, typeOptions) === typeOptions[1].value ?  findRelativeStatus(response.gameType, gameTypeOptions) : gameTypeOptions[0].value
          })
          setSearch(response.location || '')
          setParams({
            ...params,
            distributor: response.distributor,
            charity: response.charity
          })
        }
      })()
    }
  }, [])

  useEffect(() => {
    if (!validSearch) {
      setParams({
        ...params,
        distributor: '',
        charity: '',
        search: {
          id: '',
          name: '',
          type: '',
        }
      })
    }
  }, [validSearch])

  useEffect( () => {
    async function getLocation() {
      if(params.search.id) {
        const response = await getLocationById({id: params.search.id})
        setSingleUse({
          allowSingleUse: response.allowSingleUse.valueOf()
        })
      } else {
        setSingleUse({
          allowSingleUse: false
        })
      }
    }
    getLocation()
  }, [params])

  const isChanged = () => {
    if(!form.identifier
        || !form.type
        || !form.status
    ) return false
    if(form.identifier!==orig.identifier) return true
    if(form.alias!==orig.alias) return true
    if(form.status!==orig.status) return true
    if(params.search.id && params.search.id!=="" && params.search.id!==orig.locationId) return true
    if(form.gameType !== orig.gameType) return true
    return form.type !== orig.type;

  }

  const pushReactivateCommand = async () => {
    let devices = new Array();
    devices.push(id)
    console.log(devices)
    let commandParams = {
      command: 'reactivate-device',
      deviceList: devices[0],
      title: '',
      message: '',
    }
    console.log(commandParams)
    await pushDeviceCommand(commandParams)
  }

  const onFormSubmit = async () => {
    if(!form.identifier || onlySpaces(form.identifier)) return notificationError('Please provide a valid device id')
    if(form.status.toLowerCase() === 'available' && !form.locationId && !params.search.id) return notificationError('Please provide a location')
    if(((orig.status.toLowerCase() === 'blocked' && form.status.toLowerCase() !== 'blocked') || (orig.status.toLowerCase() !== 'blocked' && form.status.toLowerCase() === 'blocked')) && affiliation !== 'manufacturer') return notificationError('User does not have permission to block or unblock devices')
    if(orig.type !== form.type && affiliation !== 'manufacturer') return notificationError('User does not have permission to change device type')
    let valid = false
    if(!id) valid = await createOrUpdateDevice({  
      ...form,
      locationId: params.search.id,
    })

    if(id && form.locationId) {
      valid = await createOrUpdateDevice({id, ...form})

    } else if(id) {
      valid = await createOrUpdateDevice({ 
        id,
        ...form,
        locationId: params.search.id,
      })
    }
    if(form.locationId && valid) {
      await pushReactivateCommand();
    }

    if(valid) history({
			pathname:'/devices/list',
			search: createSearchParams({
				useRecord: 'true'
			}).toString()
		})
  }
  const gameTypeCheck = () => {
    if(form.type == 'game' && (String(form.allowSingleUse) === 'true'
        || (params.search.id && singleUse.allowSingleUse) )) {
      return false
    }
    else {
      return true
    }
  }

  return (
    <div className="new-device">
      <Head title="New Device" />
      <div className="new-device__container">
        <Divider orientation="left"><strong>Identity</strong> </Divider>
        <div className="new-device__container__row">
          <Input 
            label='Device ID *' 
            value={form.identifier} 
            onChange={(e: any) => setForm({...form, identifier: e.target.value})}
            placeholder="Device ID"
            disabled={id ? true : false}
          />
          <Input
            label='Alias (leave blank to auto-generate)'
            value={form.alias} 
            onChange={(e: any) => setForm({...form, alias: e.target.value})}
            placeholder="Alias"
            disabled={affiliation!=="manufacturer"}
          />
        </div>
        <Divider orientation="left"><strong>About</strong></Divider>
        <div className="new-cashier__container__row">

          <Radio
            label='Status'
            options={statusOptions}
            value={form.status} 
            onChange={(e: any) => setForm({...form, status: e.target.value})}
          />

          <Radio
            label='Type'
            options={typeOptions}
            value={form.type} 
            onChange={(e: any) => setForm({...form, type: e.target.value})}
          />
          <div
          hidden={gameTypeCheck()}>
            <Radio
                label='Single Use Device Game Types'
                options={gameTypeOptions}
                value={form.gameType}
                onChange={(e: any) => setForm({...form, gameType: e.target.value})}
            />
          </div>
        </div>
        <Divider orientation="left"><strong>Relation</strong></Divider>
        <div className="new-cashier__container__row">
          {((!id || id==="") || (id && !form.locationId)) &&
          <SmartSearch
            value={search}
            triggerWith={search}
            onChange={(e: string) => setSearch(e)}
            onValidSearch={setValidSearch}
            label='Location'
            status="active"
            searchBy={['location']}
            onObjValueChange={(e: any) => setParams({...params, search: e})}
            disabled={id && form.locationId ? true : false}
          />}
          {id && id!=="" && form.locationId &&
              <Input
                  label="Location"
                  placeholder="Location"
                  value={search}
                  onChange={(e: any) => {}}
                  innerProps={{id:'new-device-location'}}
                  disabled={true}
              />
          }
          {id && form.locationId && (
            <>
              <Input 
                label='Distributor' 
                value={params.distributor} 
                onChange={(e: any) => setParams({...params, distributor: e.target.value})}
                placeholder="Distributor"
                disabled
              />
              <Input 
                label='Charity' 
                value={params.charity} 
                onChange={(e: any) => setParams({...params, charity: e.target.value})}
                placeholder="Charity"
                disabled
              />
            </>
          )}

        </div>
        <Divider />
        <div className="new-cashier__container__actions">
          <CancelButton customRedirect={() => {
            history({
              pathname:'/devices/list',
              search: createSearchParams({
                useRecord: 'true'
              }).toString()
            })
          }}/>
          <Button type="primary" onClick={onFormSubmit} disabled={(!validSearch && !id) || !form.identifier || !isChanged()}>
						<p id="save-button">Save</p>
					</Button>
        </div>
      </div>
    </div>
  )
}

export default NewDevice
